/* tslint:disable */
/* eslint-disable */
export enum FinanceWithdrawReasons {
  None = 'None',
  Competitor = 'Competitor',
  Duplicate = 'Duplicate',
  CustomerChangedMind = 'CustomerChangedMind',
  CantContactCustomer = 'CantContactCustomer',
  Pricing = 'Pricing',
  LoanTerms = 'LoanTerms',
  Other = 'Other'
}
